import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as a from 'actions/devicemanagement';
import toastr from "toastr"

class DeviceSetting extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {};
    }
    submit(event) {
        if (event) {
            event.preventDefault();
        }
        var ncKey = this.getNewConfigKey();

        var cntDone = 0;
        var cntTotal = this.props.selectedSensors.length;

        var fClose = () => {
            // this function is called everytime an update request is done.
            // it updates the counter and refresh data after counter reach 100%.
            cntDone += 1;
            toastr.success(cntDone + "/" + cntTotal + " updates have been sent.");
            if (cntDone == cntTotal) { // 100%
                // Clear the form
                this.setState({
                    [ncKey]: {}
                })
                // Refresh data
                this.props.dispatch(a.fetchConfig()).then(() => {
                    toastr.success("Update is completed.")
                });
            }
        }

        // run dispatch(a.updateConfig(...)) in parallel.
        this.props.selectedSensors.forEach((ss) => {
            this.props.dispatch(a.updateConfig(ss.sensorMac, this.state[this.getNewConfigKey()], fClose));
        })
    }
    changeHandler(event) {
        var parameter = event.target.name;
        var value = event.target.value;
        var tmp = { ...(this.state[this.getNewConfigKey()] || {}) };

        if (value == "") {
            delete tmp[parameter];
        } else {
            if (event.target.type == "number") {
                value = parseInt(value);
            }
            tmp[parameter] = value;
        }

        this.setState({
            [this.getNewConfigKey()]: tmp
        });
    }
    getNewConfigKey() {
        var res = "";
        this.props.selectedSensors.forEach((ss) => res += ss.sensorId + ":" + ss.sensorMac + ";");
        return res;
    }

    renderParameters() {
        // Get MAC address list.
        var macs = [];
        this.props.selectedSensors.forEach((ss) => {
            macs.push(ss.sensorMac);
        })

        // Get the list of parameter names of all sensors.
        var parameters = [];
        macs.forEach((mac) => {
            var sensorConfig = this.props.configMap[mac];
            if (sensorConfig.currentConfig) {
                parameters = parameters.concat(Object.keys(sensorConfig.currentConfig));
            }
            if (sensorConfig.pendingConfig) {
                parameters = parameters.concat(Object.keys(sensorConfig.pendingConfig));
            }
        })
        parameters = parameters.filter(function (item, pos) {
            return parameters.indexOf(item) == pos;
        });
        parameters.sort();
        console.log(parameters);


        var newConfig = this.state[this.getNewConfigKey()] || {};
        return (
            <React.Fragment>
                {
                    parameters.map((parameter) => {
                        var readValues = {};
                        var sentValues = {};
                        var valueTypes = {};
                        var readHasEmpty = false;
                        var sentHasEmpty = false;

                        macs.forEach((mac) => {
                            var sensorConfig = this.props.configMap[mac];
                            // add sent value to map

                            if (sensorConfig.currentConfig) {
                                if (sensorConfig.currentConfig.hasOwnProperty(parameter)) {
                                    readValues[sensorConfig.currentConfig[parameter]] = true;
                                } else {
                                    readHasEmpty = true;
                                }
                            }
                            // add sent value to map
                            if (sensorConfig.pendingConfig) {
                                if (sensorConfig.pendingConfig.hasOwnProperty(parameter)) {
                                    sentValues[sensorConfig.pendingConfig[parameter]] = true;
                                } else {
                                    sentHasEmpty = true;
                                }
                            }
                            if (sensorConfig.currentConfig !== null) {
                                // add the type to map
                                valueTypes[(typeof sensorConfig.currentConfig[parameter])] = true;
                            }
                        })

                        // Get array of distinct read values.
                        readValues = Object.keys(readValues);
                        /* console.log("readValues", readValues)
                         console.log("sentValues", sentValues)
                         console.log("sentValuessentValues", readValues === sentValues)*/
                        // Get array of distinct sent values.
                        sentValues = Object.keys(sentValues);

                        // Get array of distince value types
                        valueTypes = Object.keys(valueTypes);

                        if (readHasEmpty && readValues.length > 0) {
                            readValues.push(undefined);
                        }
                        if (sentHasEmpty && sentValues.length > 0) {
                            sentValues.push(undefined);
                        }

                        // Calculate input type
                        var inputType = "null"
                        if (valueTypes.length == 0) {
                            inputType = "empty";
                        } else if (valueTypes.length == 1) {
                            switch (valueTypes[0]) {
                                case "string":
                                    inputType = "text";
                                    break;
                                case "number":
                                    inputType = "number";
                                    break;
                                default:
                            }
                        } else if (valueTypes.length > 1) {
                            inputType = "several";
                        }


                        return <tr key={parameter}>
                            <td>
                                <div className="parameter disabled">
                                    <span>{parameter}</span>
                                </div>
                            </td>
                            <td>
                                {
                                    (readValues.length == 1) ?
                                        <div className="parameter disabled">
                                            <span>{readValues[0]}</span>
                                        </div>
                                        : ((readValues.length > 1) ?
                                            <div className="parameter disabled"><span>(Several values)</span></div>
                                            : null)
                                }
                            </td>
                            <td>
                                {
                                    (sentValues.length == 1) ?
                                        <div className="parameter disabled">
                                            {sentValues[0]}
                                        </div>
                                        : ((sentValues.length > 1) ?
                                            <div className="parameter disabled"><span>(Several values)</span></div>
                                            : null)
                                }
                            </td>

                            <td>
                                {
                                    (inputType == "empty") ?
                                        null
                                        : (
                                            (inputType == "several") ?
                                                <div className="parameter disabled"><span>(Several value types)</span></div>
                                                : <input type={inputType}
                                                    name={parameter}
                                                    value={newConfig[parameter] || ""}
                                                    onChange={this.changeHandler.bind(this)}
                                                />
                                        )
                                }

                            </td>
                        </tr>
                    })
                }
            </React.Fragment>
        )
    }
    render() {
        var buttonDisabled = (Object.keys(this.state[this.getNewConfigKey()] || {}).length == 0);
        return (
            <div className={`popup-device-management bg--white ${this.props.isClicked ? "" : "popup-device-management_active bg--green"}`}>
                <div>
                    <h3 className="font--bold">DEVICE SETTINGS</h3>
                    {(this.props.selectedSensors.length > 0) ?
                        <form className="device-management-form">
                            <table >
                                <tbody>
                                    <tr className="header-tr">
                                        <th>Parameter</th>
                                        <th>Read value</th>
                                        <th>Sent Value</th>
                                        <th>New Value</th>
                                    </tr>
                                    {this.renderParameters()}
                                </tbody>
                            </table>
                            <div className="dev-manage-btn btn btn-success" type="button" onClick={this.submit.bind(this)} disabled={buttonDisabled}>
                                Apply
                            </div>

                        </form>
                        : <p>
                            Click on the sensor to edit
                        </p>
                    }
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        configMap: state.devManReducer.configMap
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DeviceSetting);



// WEBPACK FOOTER //
// ./src/components/pages/devicemanagement/devicesetting.jsx